import { useEffect, useState } from "react";
import { Routes, Route, HashRouter } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

import LoadingScreen from "./components/home/LoadingScreen";

// NUEVO
import { AuthProvider } from "./hoc/AuthContext";
import RequireAuth from "./hoc/RequireAuth";
import Login from "./components/home/Login";
import Landing from "./components/home/Landing";

// EXISTENTES
import Home from "./components/home";
import Map from "./components/map/map";
import Map3D from "./components/map/map3D";

const Router = () => {
  const [loading, setLoading] = useState(true);
  const isMobileOrTablet = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <LoadingScreen />;

  return (
    <HashRouter basename="/">
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />

          {/* Private */}
          <Route
            path="/panel"
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
          />

          <Route
            path="/map"
            element={
              <RequireAuth>
                <Map />
              </RequireAuth>
            }
          />

          <Route
            path="/map3D"
            element={
              <RequireAuth>
                <Map3D />
              </RequireAuth>
            }
          />

          {/* Mobile behavior (opcional): si quieres forzar mapa */}
          {isMobileOrTablet && (
            <Route
              path="*"
              element={
                <RequireAuth>
                  <Map />
                </RequireAuth>
              }
            />
          )}

          {/* Desktop fallback */}
          {!isMobileOrTablet && <Route path="*" element={<Landing />} />}
        </Routes>
      </AuthProvider>
    </HashRouter>
  );
};

export default Router;
